<template>
  <div>
    <v-toolbar
      flat
      color="white"
      class="mx-0 px-0"
    >
      <v-spacer />
      <v-btn
        v-if="!loading"
        color="info"
        small
        icon
        @click="toggleFilters"
      >
        <v-icon>{{ filterEnabled ? 'mdi-close' : 'mdi-filter-variant' }}</v-icon>
      </v-btn>
    </v-toolbar>

    <PaymentReceiptDashboardFilters
      v-show="!loading"
      v-if="filterEnabled"
      :initial-filters-filters="initialFiltersFilters"
      @onRequestData="requestServerData"
    />
    <v-card-actions v-if="!loading">
      <v-spacer />
      <v-btn
        text
        color="warning"
      >
        <span> {{ searchResultLabel }} </span>
      </v-btn>
    </v-card-actions>
    <v-tabs
      v-model="current_tab"
      background-color="transparent"
      color="basil"
      grow
      show-arrows
    >
      <v-tab
        v-for="item in tabItemList"
        :key="item.id"
        :href="'#' + item.id"
        @click="onTabChange(item)"
      >
        {{ item.title }}
      </v-tab>
    </v-tabs>
    <v-data-table
      fixed-header
      :height="tableHeight"
      :headers="headers"
      :items="modelList"
      :options.sync="options"
      :loading="loading"
      :server-items-length="pagination"
      :footer-props="footerProps"
      class="elevation-1"
    >
      <template v-slot:item.createdAt="{ item }">
        <v-icon
          small
          @click="gotoView(item)"
        >
          mdi-eye
        </v-icon>
        {{ appFormatDateTime(item.createdAt, 'DD.MM') }}
      </template>

      <template v-slot:item.relay="{ item }">
        <SupportNumberLink
          :model="item.relay"
          :route-name="relayViewRouteName"
        />
      </template>

      <template v-slot:item.generateAt="{ item }">
        {{ appFormatDateTime(item.generateAt) }}
      </template>
      <template v-slot:item.link="{ item }">
        <a
          target="_blank"
          :href="item.link"
        >Чек</a>
      </template>
      <template v-slot:item.startAt="{ item }">
        {{ appFormatDateTime(item.relay.startAt) }}
      </template>
      <template v-slot:item.endAt="{ item }">
        {{ appFormatDateTime(item.relay.endAt) }}
      </template>
      <!--      <template v-slot:item.error="{ item }">-->
      <!--        <span style="display: inline-block; max-width: 120px">-->
      <!--          {{item.error}}-->
      <!--        </span>-->
      <!--      </template>-->
      <template v-slot:item.options="{ item }">
        <!--        <v-btn-->
        <!--          v-if="editable"-->
        <!--          text-->
        <!--          x-small-->
        <!--          color="info"-->
        <!--          @click="onOpenEditModalShowMode(item)"-->
        <!--        >-->
        <!--          <v-icon>mdi-pencil</v-icon>-->
        <!--        </v-btn>-->
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ListMixin from '@/mixins/list-mixin.vue'
import ApiMixin from '@/mixins/api-mixin'
import SupportNumberLink from '@/components/common/listItem/supportNumberLink.vue'
import routeList from '@/router/labels'
import PaymentReceiptDashboardFilters, { externalTaskDashboardParamsMapper, PaymentReceiptFilterModel }
from '@/components/common/filter/v2/relayPaymentReveipt/index.vue'
import { pluriaizeRows } from '@/utils/plural-util'
import router from '@/router'

const RECEIPT_ACTIVE_TAB = 'receipt_active_tab'
const RECEIPT_HISTORY_TAB = 'relay-receipt_history_tab'

export default {
  name: 'WBDRelayPaymentReceiptList',
  components: {
    PaymentReceiptDashboardFilters, SupportNumberLink
  },
  mixins: [ListMixin, ApiMixin],
  data: () => ({
    initialFiltersFilters: PaymentReceiptFilterModel,
    activeFilters: undefined,
    filterEnabled: false,
    modelList: [],
    relayViewRouteName: routeList.CLIENT_RELAY_VIEW_ROUTE_NAME,
    loading: true,
    pagination: 0,
    options: {},
    tabData: {
      RECEIPT_ACTIVE_TAB,
      RELAY_EXECUTOR_VIEW_TAB: RECEIPT_HISTORY_TAB,
    },
    tabItemList: [
      { title: 'Активный', id: RECEIPT_ACTIVE_TAB },
      { title: 'История', id: RECEIPT_HISTORY_TAB },
    ],
    current_tab: null,
    headers: [
      {
        text: 'Загружен',
        align: 'left',
        sortable: false,
        value: 'createdAt',
      },
      {
        text: 'Чек',
        align: 'left',
        sortable: false,
        value: 'link',
      },
      {
        text: 'Статус',
        align: 'left',
        sortable: false,
        value: 'status',
      },
      {
        text: 'Изменен',
        align: 'left',
        value: 'generateAt',
        sortable: false,
      },
      {
        text: 'Смена',
        align: 'left',
        sortable: false,
        value: 'relay',
      },
      {
        text: 'Начало',
        align: 'left',
        value: 'startAt',
        sortable: false,
      },
      {
        text: 'Конец',
        align: 'left',
        value: 'endAt',
        sortable: false,
      },
      {
        text: 'Ошибки',
        align: 'left',
        value: 'error',
        sortable: false,
      },
      {
        text: 'Менеджер',
        align: 'left',
        value: 'supervisor',
        sortable: false,
      },
      { text: '', value: 'options' },
    ],
  }),
  computed: {
    getWorkflowLevel () {
      if (this.isHistoryTab) {
        return 'closed'
      }
      return 'open'
    },
    searchResultLabel () {
      return `Найдено: ${this.pagination} ${pluriaizeRows(this.pagination)}`
    },
    isActiveTab () {
      return this.current_tab === RECEIPT_ACTIVE_TAB
    },
    isHistoryTab () {
      return this.current_tab === RECEIPT_HISTORY_TAB
    }
  },
  watch: {
    options: {
      handler () {
        const { searchQuery } = this.initialFiltersFilters
        let filters = null
        if (searchQuery && searchQuery !== '') {
          filters = externalTaskDashboardParamsMapper(this.initialFiltersFilters)
        }

        if (this.activeFilters && Object.keys(this.activeFilters).length > 0) {
          filters = {
            ...filters,
            ...this.activeFilters
          }
        }
        this.requestList(this.options.page, this.options.itemsPerPage, filters)
      },
      deep: true,
    },
  },
  async created () {
    this.current_tab = this.tabData.RECEIPT_ACTIVE_TAB
    this.options = {
      page: 1,
      itemsPerPage: this.footerProps.itemsPerPageOptions[1],
      sortBy: ['endAt'],
      sortDesc: [true],
    }
    this.currentTabHandler()
  },
  methods: {
    gotoView (item) {
      const routeData = this.$router.resolve(
        {
          name: routeList.CLIENT_RELAY_PAYMENT_RECEIPT_VIEW_ROUTE_NAME,
          params: { id: item.id },
          query: { workflowLevel: this.getWorkflowLevel }
        }
      )
      window.open(routeData.href, '_blank')
    },
    async requestList (page, size, filters) {
      this.loading = true
      this.modelList = []
      const defaultParams = { 'page[number]': page, 'page[size]': size }
      defaultParams.workflowLevel = this.getWorkflowLevel

      let params = { ...defaultParams }
      if (filters) {
        params = {
          ...params,
          ...filters
        }
      }

      this.activeFilters = filters
      if (this.listMode) {
        params.listMode = this.listMode
      }

      await this.getRelayPaymentReceiptList(this.setModelRequestResult, params)

      this.loading = false
    },
    async requestServerData (filtersData) {
      const { filters } = filtersData
      await this.requestList(1, this.options.itemsPerPage, filters)
    },
    setModelRequestResult (requestResult) {
      if (requestResult && requestResult.error) {
        this.modelList = []
        this.loading = false
      } else {
        this.modelList = requestResult.modelList
        this.pagination = requestResult.total
        this.loading = false
      }
    },
    onTabChange (data) {
      this.current_tab = data.id || null
      this.requestList(1, this.options.itemsPerPage)
      this.updateRouteData(data.id)
    },
    async updateRouteData (activeTab) {
      this.$router.replace({
        ...this.$router.currentRoute,
        query: { current_tab: activeTab }

      })
    },
    toggleFilters () {
      this.filterEnabled = !this.filterEnabled
    },
    gotoList () {
      router.push({ name: routeList.CLIENT_RELAY_PAYMENT_RECEIPT_LIST_ROUTE_NAME })
    },
    currentTabHandler () {
      const routeQuery = this.$route.query

      if (!routeQuery) {
        return
      }
      const queryTab = routeQuery.current_tab
      this.current_tab = queryTab || this.tabData.RECEIPT_ACTIVE_TAB
    },
  },
}
</script>
